export default "__VITE_ASSET__sK0kTLr4__"